/* pl-comprar-agora — "Comprar Agora" que leva direto ao pagamento (20/10/2026).

   Decisão do Diogo: dois botões na página de produto, como no Mercado Livre e na Amazon. "Adicionar ao Carrinho" é o
   botão do tema (buy-button da agência): põe no carrinho e abre a gaveta. "Comprar Agora" põe no carrinho pelo
   /cart/add.js e abre o /checkout: o que já estava no carrinho continua lá e o cupom aplicado vai junto.

   Lê variante, quantidade e itens do próprio buy-button (a agência mantém data-variant-id e data-quantity atualizados
   quando o cliente troca a variante ou a quantidade), então os dois botões compram sempre a mesma coisa.

   Barra fixa (aparece ao rolar): o botão dela é o do tema com o texto "Comprar Agora"; ali ele passa a ir ao pagamento
   também, para o mesmo texto não fazer duas coisas diferentes. Se a ida ao pagamento falhar, cai no caminho de sempre
   (gaveta), que mostra o aviso do tema.

   Só no computador (20/10/2026, o Diogo: "vamos usar os 2 botões apenas no pc, no mobile não por enquanto"): abaixo
   de 1024 px o botão "Comprar Agora" novo nem aparece (CSS em snippets/pl-pdp-primeira-tela.liquid) e a barra fixa
   continua como sempre, pondo no carrinho e abrindo a gaveta.
*/
(function () {
  'use strict';
  if (window.plComprarAgora) return;
  window.plComprarAgora = true;

  function itens(bb) {
    if (bb.dataItems && bb.dataItems.length) {
      return bb.dataItems.map(function (i) {
        return { id: Number(i.id), quantity: Number(i.quantity) || 1 };
      });
    }
    return [{ id: Number(bb.dataset.variantId), quantity: parseInt(bb.dataset.quantity || '1', 10) || 1 }];
  }

  function avisar(area, msg) {
    var p = area && area.querySelector('.pl-comprar-agora__erro');
    if (!p) return false;
    p.textContent = msg;
    p.hidden = !msg;
    return true;
  }

  function irAoPagamento(gatilho, bb, area) {
    if (!bb || !bb.dataset.variantId || bb.hasAttribute('disabled') || bb.dataset.available === 'false') return;
    if (gatilho.getAttribute('aria-busy') === 'true') return;
    gatilho.setAttribute('aria-busy', 'true');
    avisar(area, '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens(bb) })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw d;
          return d;
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (erro) {
        gatilho.removeAttribute('aria-busy');
        var msg = (erro && (erro.description || erro.message)) || 'Não foi possível ir para o pagamento. Tente de novo.';
        if (!avisar(area, msg)) {
          // barra fixa: sem lugar para o aviso, segue pelo caminho de sempre (gaveta), que mostra o aviso do tema
          bb.dataset.plDireto = 'nao';
          bb.click();
        }
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;
      var botao = alvo.closest('[data-pl-comprar-agora]');
      if (botao) {
        e.preventDefault();
        var area = botao.closest('.main-product__buying-options');
        irAoPagamento(botao, area && area.querySelector('buy-button'), area);
        return;
      }
      var barra = alvo.closest('.main-product__shop-bar-button buy-button');
      if (barra && window.matchMedia('(min-width: 1024px)').matches) {
        if (barra.dataset.plDireto === 'nao') {
          delete barra.dataset.plDireto; // deixa o tema tratar este clique (veio do erro acima)
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation(); // o clique não chega ao buy-button: não abre a gaveta
        irAoPagamento(barra, barra, null);
      }
    },
    true
  );
})();
